import type { FaireRetailerEntity } from "../../entity_types/retailer";

export const r_discovery: FaireRetailerEntity = {
  token: "r_discovery",
  type: "retailer",
  name: "Discovery Themes Seed Retailer",
  themeTokens: [
    "discovery_theme_bold-playful-home",
    "discovery_theme_under-20-gifts",
    "discovery_theme_sustainable-kitchen",
    "discovery_theme_cozy-textures",
    "discovery_theme_statement-ceramics",
    "discovery_theme_desk-workspace",
    "discovery_theme_gifts-ship-fast",
    "discovery_theme_color-pop-living-room",
    "discovery_theme_earthy-neutrals",
    "discovery_theme_mothers-day-picks",
    "discovery_theme_pet-lover-essentials",
    "discovery_theme_summer-entertaining",
    "discovery_theme_artisan-candles",
    "discovery_theme_minimalist-bathroom",
    "discovery_theme_vintage-inspired",
    "discovery_theme_wellness-self-care",
    "discovery_theme_kids-room-refresh",
    "discovery_theme_outdoor-garden",
    "discovery_theme_bestseller-restock",
    "discovery_theme_handmade-jewelry",
    "discovery_theme_foodie-pantry",
    "discovery_theme_boho-living",
    "discovery_theme_spring-tablescapes",
    "discovery_theme_stationery-paper",
    "discovery_theme_holiday-prep",
    "discovery_theme_local-makers",
    "discovery_theme_gourmet-chocolate",
    "discovery_theme_spa-day-at-home",
    "discovery_theme_modern-farmhouse",
    "discovery_theme_baby-shower-gifts",
    "discovery_theme_cocktail-hour",
    "discovery_theme_eclectic-wall-art",
    "discovery_theme_teacher-appreciation",
    "discovery_theme_coastal-vibes",
    "discovery_theme_under-10-add-ons",
    "discovery_theme_coffee-tea-lovers",
    "discovery_theme_new-brand-discoveries",
    "discovery_theme_luxe-gifting",
    "discovery_theme_seasonal-florals",
    "discovery_theme_travel-accessories",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
